import { render, staticRenderFns } from "./newdefault.vue?vue&type=template&id=957dcda4&"
import script from "./newdefault.vue?vue&type=script&lang=js&"
export * from "./newdefault.vue?vue&type=script&lang=js&"
import style0 from "./newdefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports